import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

export const useDeleteVideo = () => {
  return useMutation(async (fieldValueId: string) => {
    await createApiWithPath("crm").delete(
      `/field-values/video/${fieldValueId}`,
    );
  });
};
